<template>
  <div class="default-table additional-table">
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="permissions.catalog.additional.actions.new"
          v-on="on"
          @click.prevent="newDialog()"
          app
          fab
          bottom
          right
          fixed
          :color="get_interface.colors.neworder"
          class="new-btn-float"
        >
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.additional.new.title }}</span>
    </v-tooltip>
    <Save
      v-if="dialog.selected"
      v-model="dialog.selected"
      :catalog="catalog"
      :id="dialog.selected.id"
      :dialog="dialog.save"
      @closed="onCloseSave"
    />
    <DataTable
      name="additional"
      :items="data"
      :tablehdrs="tableheaders.additional"
      itemkey="cod"
      sortby="cat"
      groupby="parent_cat_name"
      :sortdesc="false"
    >
      <template v-slot:groupName="{ group }">
        {{ (group ? group : lang.categories.new.no_cat) }}
      </template>
      <template v-slot:default="{ item }">
        <tr
          :key="item.id"
          @dblclick="editDialog(item)"
          class="table-row additional-row"
          :class="{ 'inactiveItem': !(item.active) || item.inactive_cat }"
        >
          <td>
            <strong>{{ item.id }}</strong>
          </td>
          <td>
            <strong>{{ item.cod }}</strong>
          </td>
          <td>
            <v-chip color="light-green" dark>
              {{ (item.cat > 0 && item.cat === item.parent_cat ? lang.categories.new.all : (item.cat > 0 ? item.cat_name : lang.categories.new.no_parent)) }}
            </v-chip>
          </td>
          <td>
            <v-tooltip top v-if="!(item.active)">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" small class="inactiveSign">
                  <v-icon small>mdi-cancel</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.additional.status.inactive }}</span>
            </v-tooltip>
            {{ item.title }}
          </td>
          <td>
            <v-chip v-if="item.description" color="blue darken-1" class="itemDescription" dark>{{ item.description }}</v-chip>
          </td>
          <td>{{ formatCurrency(item.price) }}</td>
          <td class="actionsCol">
            <Actions :additional="item" @edit="editDialog" />
          </td>
        </tr>
      </template>
      <template v-slot:mobile="{ item }">
        <tr
          :key="`mb-${item.id}`"
          @dblclick="editDialog(item)"
          class="mobile_row table-row additional-row"
          :class="{ 'inactiveItem': !(item.active) }"
        >
          <td class="mobile_col">
            <ul class="flex-content pl-2">
              <li class="flex-item" :data-label="`${lang.additional.datatable.headers.id}:`">{{ item.id }}</li>
              <li class="flex-item" :data-label="`${lang.additional.datatable.headers.code}:`">{{ item.cod }}</li>
              <li class="flex-item" :data-label="`${lang.additional.datatable.headers.category}:`">
                <v-chip color="light-green" dark>
                  {{ (item.cat > 0 && item.cat === item.parent_cat ? lang.categories.new.all : (item.cat > 0 ? item.cat_name : lang.categories.new.no_parent)) }}
                </v-chip>
              </li>
              <li class="flex-item" :data-label="`${lang.additional.datatable.headers.title}:`">
                <v-tooltip top v-if="!(item.active)">
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" small class="inactiveSign">
                      <v-icon small>mdi-cancel</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.additional.status.inactive }}</span>
                </v-tooltip>
                {{ item.title }}
              </li>
              <li class="flex-item" :data-label="`${lang.additional.datatable.headers.description}:`">
                <v-chip v-if="item.description" color="blue darken-1" class="itemDescription" dark>{{ item.description }}</v-chip>
              </li>
              <li class="flex-item" :data-label="`${lang.additional.datatable.headers.price}:`">{{ formatCurrency(item.price) }}</li>
              <li class="flex-item actions_row" :data-label="lang.additional.datatable.headers.action">
                <Actions :additional="item" @edit="editDialog" />
              </li>
            </ul>
          </td>
        </tr>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'
import Actions from './Actions'
import Save from '../Save'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import list from '@/mixins/defaults/list_dialog'

export default {
  components: { DataTable, Actions, Save },
  mixins: [ appdata, utils, list ],
  props: {
    catalog: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      default: { ...defaults.blank.additional(this.catalog) },
      pageName: 'additional'
    }
  },
  computed: {
    data: function () {
      const additional = this.get_data.additional || []
      return additional.filter(adt => adt.catalog === this.catalog) || []
    }
  }
}
</script>

<style src="../styles/list.scss" lang="scss"></style>
